var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadIconSmall = function SvgUploadIconSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 50,
    viewBox: "0 0 38 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M18.937.001c-.474.016-.919.22-1.312.562l-16.992 16c-.772.747-.878 1.942-.094 2.813.7.778 2.082.813 2.842.093l13.62-12.843V40a2 2 0 1 0 3.998 0V6.626l13.619 12.843c.76.72 2.108.653 2.842-.093.775-.789.69-2.077-.094-2.813l-16.992-16c-.46-.405-.963-.578-1.437-.562m-16.93 46a2 2 0 0 0 0 3.999h33.986a2 2 0 0 0 0-4z"
  })));
};
export default SvgUploadIconSmall;